import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loader-component',
    templateUrl: './loader-component.component.html',
    styleUrls: ['./loader-component.component.scss'],
    standalone: false
})
export class LoaderComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
